import { render, staticRenderFns } from "./DocButton.vue?vue&type=template&id=6b329af0&scoped=true&"
import script from "./DocButton.vue?vue&type=script&lang=js&"
export * from "./DocButton.vue?vue&type=script&lang=js&"
import style0 from "./DocButton.vue?vue&type=style&index=0&id=6b329af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b329af0",
  null
  
)

export default component.exports